<template>
  <v-app>
    <Toolbar />

    <v-content>
      <v-container>
        <router-view></router-view>
        <Snackbar v-if="snackbar.status" />
      </v-container>
    </v-content>

    <Footer />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Toolbar from './components/Toolbar/Toolbar';
import Snackbar from './core/components/Snackbar';
import Footer from './components/Footer/Footer';


export default {
  name: 'App',
  data() {
    return {}
  },
  components: { Toolbar, Snackbar, Footer },
  computed: mapGetters(['snackbar']),
  methods: mapActions(['checkIfAuthenticated', 'getUserEmailAddress']),
  async created() {
    const { error } = await this.checkIfAuthenticated();
    if (!error) {
      await this.getUserEmailAddress();
    }
  }
};
</script>

<style>
@import './assets/styles/environments.css';
@import './assets/styles/header.css';
@import './assets/styles/signin.css';
@import './assets/styles/signup.css';
@import './assets/styles/verify.css';

@media (min-width: 960px) {
  #content-desktop {
    max-width: 70%;
  }

  #content-desktop:last-child {
    margin-bottom: 30px
  }
}

.container {
  padding: 0;
  max-width: 100%;
}

.v-content {
  margin-top: 0px;
}

#app {
  background: #fff;
}

.v-input__slot {
  border-bottom: 1px solid #dddddd;
}
</style>